export enum TicketTabType {
    log = 1,
    access = 2,
    notes = 3,
    ticketAuthor = 4,
    linkedTickets = 5,
    faq = 6,
    externalApp = 7,
    editFields = 8,
}
